module.exports = __webpack_public_path__ + "static/media/GAOFEN 4.9bd1f120.czml";